__turbopack_context__.v({
  "brandLtr": "why-k-lab-module__Lc5fIW__brandLtr",
  "cell": "why-k-lab-module__Lc5fIW__cell",
  "cellLabel": "why-k-lab-module__Lc5fIW__cellLabel",
  "cellText": "why-k-lab-module__Lc5fIW__cellText",
  "colHeadDo": "why-k-lab-module__Lc5fIW__colHeadDo",
  "colHeadDont": "why-k-lab-module__Lc5fIW__colHeadDont",
  "colHeadWho": "why-k-lab-module__Lc5fIW__colHeadWho",
  "colHeads": "why-k-lab-module__Lc5fIW__colHeads",
  "eyebrow": "why-k-lab-module__Lc5fIW__eyebrow",
  "headline": "why-k-lab-module__Lc5fIW__headline",
  "intro": "why-k-lab-module__Lc5fIW__intro",
  "klabCell": "why-k-lab-module__Lc5fIW__klabCell",
  "klabRow": "why-k-lab-module__Lc5fIW__klabRow",
  "klabText": "why-k-lab-module__Lc5fIW__klabText",
  "outro": "why-k-lab-module__Lc5fIW__outro",
  "row": "why-k-lab-module__Lc5fIW__row",
  "section": "why-k-lab-module__Lc5fIW__section",
  "table": "why-k-lab-module__Lc5fIW__table",
});
